export { default as ComposerProductsDock } from './ComposerProductsDock';
